<script>
import { mapActions } from 'vuex'
import VuexContextMenu from '@/components/VuexContextMenu.vue'
import { event } from 'quasar';
export default {
    watch: {
        '$route' (to) {
            if (to.meta?.title) {
                window.top.document.title = to.meta.title
            }
        }
    },
    components: {
        VuexContextMenu
    },
    data() {
        return {
            contextMenuVisible: false,
        }
    },
    methods: {
        ...mapActions({
            clearContextMenu: 'clearContextMenu',
            addContextMenuItems: 'addContextMenuItems'
        }),
    },
}
</script>
<template >
    <q-menu touch-position context-menu >
        <VuexContextMenu>
        </VuexContextMenu>
    </q-menu>        
    <router-view>
    </router-view>
</template>

<style>
@import 'quasar/src/css/index.sass';
@font-face{
    font-family: "asap";
    src: url("@/assets/fonts/Asap-VariableFont_wdth,wght.ttf")
}
*{
    font-family: "asap";
}
.page-title{
    font-size: 3em;
    margin: 10px 0px;
    font-weight: 600;
}
.page-subtitle{
    font-size: 1.5em;
    margin: 20px 0px;
    font-weight: 400;
}

::-webkit-scrollbar {
  width: 10px; /* Ancho de la barra de desplazamiento */
}

::-webkit-scrollbar-track {
  background: #f1f1f1; /* Color del fondo de la barra */
}

::-webkit-scrollbar-thumb {
  background: #888; /* Color del thumb (barra que se mueve) */
  border-radius: 5px; /* Bordes redondeados */
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>

<style lang="scss" >
@import '@/assets/ansi_styles.css';
</style>

<style>
.auth-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background-color: #ffffff;
}

.auth-card-top {
    min-height: 260px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.auth-card-middle {
    min-height: 400px;
    flex: 1;
    /* display: flex; */
    /* flex-direction: column;
    justify-content: center; */

}

.auth-card-bottom {
    min-height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

.auth-logo {
    width: 300px;
    object-fit: contain;
}

.auth-card {
    width: 450px;
    flex-shrink: 0;
    margin: 0 auto;
    border-radius: 0 12px 12px 0;
    box-shadow: none;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1) !important;
    border-radius: 12px !important;
}
</style>